module.exports = __webpack_public_path__ + "static/love-character-02af03a573e66a7fc8a3e9df3ff65607.png";